import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import axios from "axios";

import ManageRentalInvoices from "../../../ConfirmShow/components/ManageRentalInvoices";

// The Rental Invoices card shown for room-rental events. Shared by the Finances tab
// and the Dashboard, it self-fetches from event_rental_invoices — a single, cheap,
// authorized endpoint — so both surfaces render identically without the page payloads
// carrying (or having to keep in sync) the rental slice. The endpoint authorizes
// `:manage FinanceItem`, so a :read-only role on the Dashboard simply gets nothing.
//
// Permission management (the section "Set Permissions" menu) needs a live
// SetPermissionsPopup bound to the same usePermissionSet instance, so the owning
// parent supplies fetchPermissionSet. The Dashboard has no such popup and passes
// showSectionMenu={false} to keep the admin menu from being a dead affordance there.
const RentalInvoicesCard = ({
  rentalInvoicesUrl,
  team,
  csrfToken,
  confirm,
  fetchPermissionSet,
  showSectionMenu,
}) => {
  const [data, setData] = useState(null);
  const [section, setSection] = useState(null);

  useEffect(() => {
    if (!rentalInvoicesUrl) return undefined;
    let active = true;
    axios.get(rentalInvoicesUrl)
      .then(({ data: fresh }) => {
        if (!active) return;
        setData(fresh);
        setSection(fresh.rentalInvoicesPageSection);
      })
      .catch(() => {});
    return () => { active = false; };
  }, [rentalInvoicesUrl]);

  if (!data || !data.isRental || !section) return null;

  return (
    <div className="d2-card finances-tab rental-invoices-card">
      <ManageRentalInvoices
        csrfToken={csrfToken}
        team={team}
        confirm={confirm}
        currentUser={data.currentUser || {}}
        rentalInvoices={data.rentalInvoices || []}
        confirmPageSection={section}
        fetchPermissionSet={fetchPermissionSet}
        updateConfirmPageSection={setSection}
        showSectionMenu={showSectionMenu}
      />
    </div>
  );
};

RentalInvoicesCard.propTypes = {
  rentalInvoicesUrl: PropTypes.string,
  team: PropTypes.object.isRequired,
  csrfToken: PropTypes.string,
  confirm: PropTypes.object.isRequired,
  fetchPermissionSet: PropTypes.func,
  showSectionMenu: PropTypes.bool,
};

RentalInvoicesCard.defaultProps = {
  fetchPermissionSet: () => {},
  showSectionMenu: true,
};

export default RentalInvoicesCard;
